// extracted by mini-css-extract-plugin
export default {"pageloader":"Loader_pageloader__igB7k","apploader":"Loader_apploader__YR7ok","loader":"Loader_loader__+lRPl","spin":"Loader_spin__E4RJ0"};